
import Utility from "../../../../../../utility/utility";
import { JdPokerComponent } from "../../component/jd_poker_component";
import { JdSeatComponent } from "../../component/jd_seat_component";
import { JdHelp } from "../../help/jd_help";
import { JdConst } from "../../data/jd_define";
import JdAnimEffect from "../../component/jd_animation_effect";
import JdAtlasHandleComp from "../../component/jd_atlas_component";
import { IUserData } from "../../../../../public/model_data";
import { JdDealCardsEffect } from "../../component/jd_deal_cards_effect";
import ViewBase from "../../../../../../framework/core/mvvm/view_base";
import { TexasHoldSprite } from "../../../../../texasholdem/module/table/component/texas_hold_sprite";
import { Jd } from "../../../../net/proto/proto_jd_game";
import TexasAnimEffect from "../../../../../texasholdem/module/table/component/texas_animation_effect";
import GameUtil from "../../../../../../utility/game_util";
import AppData from "../../../../../public/const/app_data";
import { PokerCommonColor } from "../../../../../k9/module/table/component/poker_com_color";
import TablePokerBase from "../../../../../table/module/table_base/table_poker_base";

export class JdSeatView extends ViewBase{
    //当前座位Node
    seatNode:cc.Node;

    //UI组件元素
    seatComponent:JdSeatComponent;
    //计时器id
    private intervalID:number = null;

    pokerPos:cc.Vec2[] = [];

    pokerangle:number[] = [];

    smallCardsAngle:number[] = [];

    Init(){
        this.seatComponent = this.seatNode.getComponent(JdSeatComponent);
        for (let eff of this.dealCardsEffect) {
            eff.init();
        }
        this.onInit();
    }

    get playerHands():PokerCommonColor[]{
        return this.seatComponent.mHands;
    }

    get betEndNode():cc.Node{
        return this.seatComponent.betEndNode;
    }

    get maxCardNode():cc.Node{
        return this.seatComponent.maxCardNode;
    }

    get smallCards():cc.Node[]{
        return this.seatComponent.smallCards;
    }

    get clickNode():cc.Node{
        return this.seatComponent.active
    }

    get handEffect(){
        return this.seatComponent.handCardEffect;
    }

    get effectNode(){
        return this.seatComponent.effectNode;
    }

    get avatarNode(){
        return this.seatComponent.avatarNode;
    }

    setAllInNode(show:boolean){
        //this.seatComponent.allInNode.active = show;
    }

    get isNoDestroy():boolean{
        if (this.seatNode != null && cc.isValid(this.seatNode, true)) {
            return true;
        }
        return false;
    }

    isShowDebugInfo(isShow:boolean,str?:string){
        this.seatComponent.debugInfo.active = isShow;
        let node = this.seatComponent.debugInfo.getChildByName('debugInfo')
        if (isShow) {
            node.getComponent(cc.Label).string = str;
        }else{
            this.seatComponent.debugInfo.active = false
        }
    }

    setDebugPos(p:cc.Vec2){
        if (AppData.userConnectEnvi != 0) {
            this.seatComponent.debugInfo.position = p;
        }
    }

    updatePoker(uid:number){
        let pokerBaseList = this.seatComponent.smallCtrlNode.getComponentsInChildren(TablePokerBase);
        if (pokerBaseList) {
            pokerBaseList.forEach((pokerBase)=>{
                pokerBase.uid = uid;
                pokerBase.onUpdateBack();
            });
        }
    }

    //重置手牌
    resumeHands(cards:number[]){
        for (let del of this.dealCardsEffect) {
            del.reset();
        }
        if (!cards) {
            return;
        }
        for (let idx = 0; idx <cards.length; idx++) {
            let card = cards[idx];
            if (card == 0) {
                let def = this.dealCardsEffect[idx];
                def.resumeHands();
            }

            let hand = this.smallCards[idx];
            let data = this.handEffect.getTransform(cards.length,idx)
            let pos = hand.parent.convertToNodeSpaceAR(data.worldPos);
            hand.position = pos;
            hand.scale = data.scale;
            hand.angle = data.angle;
        }
    }

    showSmallCards(cards:number[]){
        if (!cards) {
            return;
        }
        for (let idx = 0; idx <cards.length; idx++) {
            let hand = this.smallCards[idx];
            let def = this.dealCardsEffect[idx];
            def.resumeHands();
            let data = this.handEffect.getTransform(cards.length,idx)
            let pos = hand.parent.convertToNodeSpaceAR(data.worldPos);
            hand.position = pos;
            hand.scale = data.scale;
            hand.angle = data.angle;
        }
    }

    //-------------准备发牌
    beginDealCards(haveCards:number,isMySelf:boolean){
        this.seatComponent.smallPoker.opacity = 255;
        for (let dc of this.dealCardsEffect) {
            dc.reset();
        }
        if (!isMySelf) {
            for (let i = 0; i < haveCards; i++) {
                let card = this.dealCardsEffect[i];
                if (card) {
                    card.resumeHands();
                }      
            }
        }
    }

    resetHands(){
        for (let dc of this.dealCardsEffect) {
            dc.reset();
        }
    }

    //发牌
    dealCards(start:cc.Node,index:number,cards:number[]){

        let smallNode = this.smallCards[index];

        let data = this.handEffect.getTransform(cards.length,index)
        if (data) {
            let pos = smallNode.parent.convertToNodeSpaceAR(data.worldPos);
            this.dealCardsEffect[index].dealCardsAction(start,()=>{
    
            },pos,data.angle);
    
            if (cards.length == 3) {
                this.handEffect.playerDealCardsAnim(cards.length,this.smallCards);
            }
        }
    }

    //弃牌
    throwCardsAction(source:cc.Node,cardsCount:number){
        for (let idx = 0; idx < cardsCount; idx++) {
            let dc = this.dealCardsEffect[idx];
            dc.throwCardsAction(source);
        }
    }

    checkBetAction(goldNumb:number,func?:Function){
        this.goldRoot.stopAllActions();
        this.seatComponent.betMoveEffect.checkBet(goldNumb);
        JdHelp.delay(this.seatComponent.userGold.node,()=>{
            if (func) {
                func();
            }
        },0.3)
    }

    guiChi(target:cc.Node,func?:Function){
        this.seatComponent.betMoveEffect.guiChi(target,func);
    }

    //获得bet
    obtainBet(target:cc.Node,gold:number,comp:Function){
        this.seatComponent.betMoveEffect.obtainBet(target,this.betEndNode,gold,comp);
    }

    showBet(gold:number){
        this.goldRoot.stopAllActions();
        this.seatComponent.betMoveEffect.showBet(gold);
    }

    setServerIndex(index:number){
        this.seatComponent.setServerID(index);
    }

    setServerActive(isShow:boolean){
        this.seatComponent.serverID.node.active = isShow;
    }

    setBetNumb(bet:number){
        let numb = JdHelp.addThousands(bet);
        this.seatComponent.goldNumb.string = numb;
    }

    setBet(isShow:boolean){
        this.goldRoot.active = isShow;
    }

    //设置操作描述
    setOperatorDes(value:string,opType:JdConst.OperatorType){
        let anim = this.seatComponent.operatorAnim;
        let operatorNode = this.seatComponent.operatorNode;
        anim.active = (opType == 1);
        operatorNode.active = (opType == 0);
        if (opType == JdConst.OperatorType.Anim_Op) {
            anim.getComponent(JdAnimEffect).playAllAnim();
        }else if (opType == JdConst.OperatorType.Image_Op) {
            let texas_hold_sprite = operatorNode.getComponent(TexasHoldSprite);
            texas_hold_sprite.setSprite(value);
            operatorNode.scale = 1;
            operatorNode.stopAllActions();
            if (value == '7') {
                this.allInAction(operatorNode);
            }
        }else if (opType == JdConst.OperatorType.Name_Op) {
            let str = Utility.filterPlayerName(value);
        }
    }

    allInAction(node:cc.Node){
        let big = cc.scaleTo(0.1,1.3);
        let small = cc.scaleTo(0.07,1);
        let seq = cc.sequence(big,small);
        node.stopAllActions();
        node.runAction(seq)
    }

    get winner(){
        return this.seatComponent.winner;
    }

    get dealCardsEffect():JdDealCardsEffect[]{
        return this.seatComponent.twoSmallCards;
    }

    get animationNode():cc.Node{
        return this.seatComponent.animationNode;
    }

    //信息节点
    get inforNode():cc.Node{
        return this.seatComponent.active;
    }

    get goldRoot(){
        return this.seatComponent.goldRoot;
    }

    get colorSlider(){
        return this.seatComponent.countDown;
    }

    //最大牌型
    animMaxCardtype(cardtype:number,cardPoint:number){
        let str = '0';
        if (cardtype > 6) {
            cc.error('牌型类型错误:',cardPoint);
            return;
        }
        if (cardtype == 1) {//牌型类型是单牌，看点数
            str = cardPoint.toString();
        }else{
            str = 'public_' + cardtype;
        }

        let atlas = this.animationNode.getComponent(JdAtlasHandleComp);
        atlas.fillSprites([str])
    }

    playGrades(isPlay:boolean,num?:number){
        let gradesNode = this.seatComponent.gradesNode;
        gradesNode.active = isPlay;
        if (isPlay) {
            let comp = gradesNode.getComponent(TexasAnimEffect);
            comp.playAnim(0)
            let lab = cc.find('node/numb',gradesNode).getComponent(cc.Label);
            let tempNumb = Math.abs(num);
            let gold = GameUtil.currencyFormatting(tempNumb);
            let str = num>0 ? '+' + gold:'-'+gold;
            lab.string = str;
        }
    }

    //赢家
    showWinAnim(seatInfo:Jd.ISeatInfo,isFold:boolean,animEnd?:Function,){
        this.animationNode.active = true;
        let nodes = this.seatComponent.animationNodes
        let anim = this.animationNode.getComponent(JdAnimEffect);
        nodes[1].active = false;
        nodes[0].active = false;

        if (seatInfo && seatInfo.cardType != 0 && !isFold) {
            nodes[1].active = true;

            this.animMaxCardtype(seatInfo.cardType,seatInfo.cardPoint);
            anim.playAnim(1);
            nodes[1].stopAllActions();
            JdHelp.delay(nodes[1],()=>{
                // nodes[0].active = true;
                // anim.playAnim(0);
                if (animEnd) {
                    animEnd();
                }
            },JdConst.vectorShowTime)

        }else{
            nodes[0].active = true;
            anim.playAnim(0);
            if (animEnd) {
                animEnd();
            }
        }
    }

    isShowWinAnim(isShow:boolean){
        this.animationNode.active = isShow;
        this.seatComponent.winAnim.active = false;
        let nodes = this.seatComponent.animationNodes
        for (let anim of nodes) {
            anim.active = false;
        }
    }

    showHands(isShow:boolean){
        this.seatComponent.showHands(isShow);
    }

    //显示牌型类型
    showMaxCardType(key:string){
        let atlas = this.maxCardNode.getComponent(JdAtlasHandleComp);
        atlas.fillSprites([key])
    }
    //牌型类型的显示
    showMaxCardNode(isShow:boolean){
        this.maxCardNode.active = isShow;
    }

    //飘
    flyGameLab(isWin:boolean,numb:number,func?:Function){
        // numb = JdHelp.getRightNumb(numb);
        // let node = this.seatComponent.winAnim;
        // node.active = true;
        // let anim = node.getComponent(JdAnimEffect)
        // let suzi = cc.find('anim_common_shuzi/shuzi',node);
        // let str = GameUtil.currencyFormatting(numb)
        // let pur = str.replace('.','a');
        // JdHelp.setNodeString(suzi,'+' + pur)
        // anim.playAllAnim();
        if (func) {
            func();
        }
        this.seatComponent.showScore(numb);
    }

    hideOpTimeState(){ 
        this.colorSlider.hide();
    }

    //time 还剩多久
    setOpTime(time:number,totalTime:number,isPlayer:boolean){
        this.colorSlider.setOpTime(time,totalTime,isPlayer);
    }


    onInit() {
        this.seatComponent.showHands(false);
        this.animationNode.active = false;
        this.pokerPos.length = 0;
        //----end 位置 
        for (let index = 0; index < 3; index++) {
            let node = this.playerHands[index].node
            this.pokerPos.push(node.position);
            this.pokerangle.push(node.angle);
            
        }
        this.smallCardsAngle.push(8);
        this.smallCardsAngle.push(-8);
        this.smallCardsAngle.push(-16);

        this.setAllInNode(false);
        this.playGrades(false);
        this.colorSlider.hide();
        this.isShowDebugInfo(false);
        this.seatComponent.hideScores();
    };

    //取消计时器
    cancleSlider(){
        this.seatComponent.countDown.node.stopAllActions();
        if (this.intervalID) {
            this.cancelSchedule(this.intervalID);
            this.intervalID = null;
        }
    }

    recycleCheckBet(){
        this.seatComponent.betMoveEffect.recycleAllBet();
    }

    playingReset(){
        this.cancleSlider();
        this.winner.active = false;
        this.setServerActive(false);
    }

    //游戏结束
    reset(){
        //停止计时器
        this.seatComponent.winAnim.active = false;
        this.cancleSlider();
        this.winner.active = false;
        this.showHands(false);
        this.animationNode.active = false;
        this.seatComponent.operatorAnim.active = false;
        this.showMaxCardNode(false);
        this.setServerActive(false);
        this.setAllInNode(false);
        this.seatComponent.hideScores();
        for (let ph of this.playerHands) {
            ph.code = 0;
            ph.stopPokerAction();
        }
        for (let del of this.dealCardsEffect) {
            del.reset();
        }
        this.betEndNode.stopAllActions();
        this.isShowDebugInfo(false);
    };

    clear(){
        this.seatComponent.betMoveEffect.clear();
    }
}
